<template>
    <svg
        class="pair-perspective-mark"
        :width="diagonal ? 66 : 88"
        :height="56"
        :viewBox="diagonal ? '0 0 66.0979 61.6592' : '0 0 88 56'"
        fill="none"
        aria-hidden="true"
        focusable="false">
        <circle :cx="diagonal ? 25.5619 : 28" :cy="diagonal ? 36.1928 : 28" :r="diagonal ? 25.4643 : 28" :fill="viewerColor" />
        <circle class="colleague-dot" :cx="diagonal ? 40.6322 : 60" :cy="diagonal ? 25.5424 : 28" :r="diagonal ? 25.4643 : 28" :fill="colleagueColor" />
    </svg>
</template>

<script setup lang="ts">
import { PERSPECTIVE_TYPES } from "~vue/pages/perspectiveTypes";
import { getPerspectiveColor } from "~vue/utils/perspectiveUtils";
import { computed } from "vue";

const props = defineProps<{ viewerArchetype?: string | null; colleagueArchetype?: string | null; diagonal?: boolean }>();

function archetypeColor(archetype: string | null | undefined): string {
    const letters = Object.keys(PERSPECTIVE_TYPES).find((code) => PERSPECTIVE_TYPES[code].title === archetype);
    return getPerspectiveColor(letters) ?? "var(--color-border)";
}

const viewerColor = computed(() => archetypeColor(props.viewerArchetype));
const colleagueColor = computed(() => archetypeColor(props.colleagueArchetype));
</script>

<style scoped>
@layer components {
    .pair-perspective-mark {
        isolation: isolate;
    }

    .colleague-dot {
        mix-blend-mode: multiply;
    }
}
</style>
